import { Grid, Typography, Button } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React from 'react'
import SubCard from 'ui-component/cards/SubCard'
import TotalIncomeDarkCard from 'views/AdminDashboard/Default/TotalIncomeDarkCard'
import TotalOrderLineChartCard from 'views/AdminDashboard/Default/TotalOrderLineChartCard'
import TotalOrderLineChartCardGreen from 'views/AdminDashboard/Default/TotalOrderLineChartCardGreen'
import { GiReceiveMoney } from "react-icons/gi";
import { TbUsersGroup } from "react-icons/tb";
import { TiDeviceDesktop } from "react-icons/ti";
import TransactionTable from './Components/wallet/TransactionTable'
import { useState } from 'react'
import AddMoneyTab from './Components/wallet/AddMoneyTab'
import { useNavigate } from 'react-router'
import { IoMdArrowBack } from "react-icons/io";
import { useEffect } from 'react'
import { GetSummary } from 'API/DS_Wallet/api'
import { FaThList } from "react-icons/fa";
// import { HiUserGroup } from "react-icons/hi";
import BackdropLoader from './Components/General/Loader'




const Wallet = () => {
    const PaymentOptions = [
        {
            name: "Sign on",
            image: <GiReceiveMoney />

        },
        {
            name: "CSP Mapping",
            image: <TbUsersGroup />
        },
        {
            name: "Hardware",
            image: <TiDeviceDesktop />
        }

    ]

    const QuickLinksOption = [
        {
            name: "Request",
            image: <FaThList />

        },
        // {
        //     name: "List of agents",
        //     image: <HiUserGroup />

        // }
        

    ]
    const [AddType, setAddType] = useState(null)
    const [OpenTab, setOpenTab] = useState(null)
    const [PaymentOption, setPaymentOption] = useState(null)

    const [SummaryData, setSummaryData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const handleAddType = (type) => {
        setAddType(type)
        setOpenTab(true)
        setPaymentOption('online')
    }


    const handleGetSummary = () => {
        GetSummary(setSummaryData,setIsLoading)
    }

    useEffect(() => {
        GetSummary(setSummaryData,setIsLoading)
    }, [])


    console.log("SummaryData", SummaryData);


    const handleBack = () => {
        setOpenTab(false)
        setPaymentOption(null)
        setAddType(null)
    }

    const handleAddBankClaim = () => {
        setOpenTab(true)
        setPaymentOption('bank_deposit')
    }

    const Nav = useNavigate()


    return (
        OpenTab ?
            <Grid container>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >
                    <SubCard title="Add Money" sx={{ height: '70vh' }}>
                        <Button variant='outlined' sx={{
                            mb: 1,
                        }} onClick={() => handleBack()}><IoMdArrowBack /></Button>
                        <AddMoneyTab category={AddType} payment_option={PaymentOption} handleBack={handleBack} />
                    </SubCard>
                </Grid>
            </Grid>
            :
            <Grid container spacing={2}>
                <BackdropLoader open={isLoading} />
                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <TotalOrderLineChartCard handleAddType={handleAddType} summaryData={SummaryData} />
                </Grid>

                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <TotalOrderLineChartCardGreen handleAddType={handleAddType} summaryData={SummaryData} />
                </Grid>
                <Grid item xl={4} lg={4} md={12} sm={12} xs={12} spacing={1}>
                    <Stack spacing={1} justifyContent='space-between'>
                        <TotalIncomeDarkCard summaryData={SummaryData} />
                        <Button variant='contained' color='secondary' fullWidth onClick={() => handleAddBankClaim()}>Claim Bank Deposit</Button>
                    </Stack>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <SubCard title="Payments">
                        <Grid container gap={3} >
                            {
                                PaymentOptions.map((option, index) => (
                                    <Grid item xl={2} lg={2} md={4} sm={4} xs={12} key={index}>
                                        <Stack alignItems='center' gap={1} sx={{ cursor: 'pointer', width: 'fit-content' }} onClick={() => Nav('/ds/payment', {
                                            state: {
                                                payment_type: option.name
                                            }
                                        })}>
                                            <Box sx={{ padding: '20px', borderRadius: '50%', backgroundColor: '#F3F6E9', aspectRatio: '1/1', fontSize: '30px' }}>{option.image}</Box>
                                            <Typography variant='h5'>{option.name}</Typography>
                                        </Stack>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </SubCard>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <SubCard title="Quick links">
                        <Grid container gap={3} >
                            {
                                QuickLinksOption.map((option, index) => (
                                    <Grid item xl={2} lg={2} md={4} sm={4} xs={12} key={index}>
                                        <Stack alignItems='center' gap={1} sx={{ cursor: 'pointer', width: 'fit-content' }} onClick={() => Nav('/ds/payment', {
                                            state: {
                                                payment_type: option.name
                                            }
                                        })}>
                                            <Box sx={{ padding: '20px', borderRadius: '50%', backgroundColor: '#F3F6E9', aspectRatio: '1/1', fontSize: '30px' }}>{option.image}</Box>
                                            <Typography variant='h5'>{option.name}</Typography>
                                        </Stack>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </SubCard>
                </Grid>

                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <SubCard title="Transaction History">
                        <TransactionTable handleGetSummary={handleGetSummary}/>
                    </SubCard>
                </Grid>
            </Grid>
    )
}

export default Wallet
